/*
 * @Description: 装载全局方法、组件
 * @Date: 2021-03-19 21:50:38
 */
export { setupDirectives } from '@/plugins/directives';
export { setupGlobalComponents } from '@/plugins/global-components';
export { setupGlobalMethods } from '@/plugins/global-methods';
import requireIcons from './require-icons';
requireIcons();
